import DynamicFieldList from "./DynamicFieldList";

export default DynamicFieldList;



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFieldList/index.js